import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { useStoreState } from 'easy-peasy';

import client from '../../../../utils/apolloClient';
import Layout from '../../../../components/global/Layout';
import {
  Loading,
  Pagination,
  Table,
  Box,
  Message,
} from '../../../../components/elements';
import Header from './Header';
import EmailTemplateList from './EmailTemplateList';
import Search from './Search';

const searchNotificationCampaignsQuery = gql`
  query searchNotificationCampaignsQuery($input: SearchInput) {
    search_notification_campaigns(input: $input) {
      notification_campaign_listing {
        notification_campaign_id
        user_id
        total_recipients
        title
        template_id
        status
        source
        total_recipients
        sent_success
        sent_failed
        reply_to
        platform
        copy_emails
        audit {
          created_at
          created_by
          updated_at
          updated_by
        }
      }
      total_size
      total_pages
    }
  }
`;

const EmailCampaignTemplates = () => {
  const { userId } = useStoreState(state => state.auth);
  const [status, setStatus] = useState({ value: 'PENDING', label: 'PENDING' });
  const [notificationTitle, setNotificationTitle] = useState();

  const [sort, ,] = useState('UPDATED_DESC');
  const [page, setPage] = useState(0);
  const currentPage = parseInt(page, 10) - 1 >= 0 ? parseInt(page, 10) - 1 : 0;
  const [pageCount, setPageCount] = useState(0);
  const [totalElements, setTotalElements] = useState();
  const listSize = 50;

  const input = { user_id: userId };

  const notification_campaign_filter = {};

  const statusF = status.value === 'ALL' ? null : status.value;

  Object.assign(
    notification_campaign_filter,
    { title: notificationTitle },
    statusF && { status: statusF },
  );

  Object.assign(
    input,
    { from: currentPage * listSize, size: listSize },
    { sort },
    {
      filter: {
        notification_campaign_filter,
      },
    },
  );

  return (
    <Layout>
      <Header />
      <Box>
        <Search
          status={status}
          setStatus={v => {
            setPage(0);
            setStatus(v);
          }}
          notificationTitle={notificationTitle}
          setNotificationTitle={v => {
            setPage(0);
            setNotificationTitle(v);
          }}
        />
        <br />
        {totalElements > 0 && (
          <Pagination
            pageFrom={currentPage * listSize}
            pageCount={pageCount}
            listSize={listSize}
            totalElements={totalElements}
            currentPage={currentPage}
            handlePageClick={value => setPage(value.selected + 1)}
          />
        )}
        <Table>
          <thead>
            <tr>
              <th>
                <div>
                  <span>Title</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Platform</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Reply to Email Id</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Copy to Email Id</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Total Recipients</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Send Success</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Send Failed</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Status</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Actions</span>
                </div>
              </th>
              {/* <th>
                <div>
                  <span> </span>
                </div>
              </th> */}
            </tr>
          </thead>
          <Query
            query={searchNotificationCampaignsQuery}
            variables={{ input }}
            fetchPolicy="network-only"
            client={client.clientPrivate}
          >
            {({ data, loading, error, refetch }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                return <Message>{error.message}</Message>;
              }

              return (
                <View
                  data={data}
                  setPageCount={setPageCount}
                  setTotalElements={setTotalElements}
                  refetch={refetch}
                />
              );
            }}
          </Query>
        </Table>
      </Box>
    </Layout>
  );
};

const View = ({ data, setPageCount, setTotalElements, refetch }) => {
  const { search_notification_campaigns } = data;
  useEffect(() => {
    setPageCount(search_notification_campaigns.total_pages);
    setTotalElements(search_notification_campaigns.total_size);
  }, [search_notification_campaigns]);

  return (
    <tbody>
      {search_notification_campaigns.notification_campaign_listing &&
        search_notification_campaigns.notification_campaign_listing.map(
          campaign => (
            <EmailTemplateList
              campaign={campaign}
              refetch={refetch}
              disabled={campaign.status !== 'PENDING'}
            />
          ),
        )}
    </tbody>
  );
};

export default EmailCampaignTemplates;
